{
  "sidenavMenuCloseTooltip": "關閉選單",
  "sidenavMenuLockTooltip": "按一下以鎖定選單",
  "toggleSideNav": "切換側邊導覽選單"
}
